import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import {
  ATLTinckerpreneurTarget,
  ATLTinckerpreneurObjective,
  ATLTinkerpreneurBanner,
  ATLTinkerpreneurGuidelines,
  ATLTinkerpreneurSessionCalendar,
  ATLTinkerpreneurPhasesRoadmap,
  ATLTinckerpreneurDisclaimer,
  ATLTinkerpreneurDeadlineNotice,
} from "../components/ATLTinckerpreneur";
import { LanguageSwitcher } from "../components/shared";

const Section = styled.div`
  margin-top: 35px;

  @media (min-width: 992px) {
    margin-top: 55px;
  }
`;

const Box = styled.div`
  font-size: 18px !important;
  color: #000 !important;
  border: 3px solid #ff8f4e;
  border-radius: 10px;

  @media (max-width: 768px) {
    font-size: 14px !important;
  }
`;

const AwardTxt = styled.div`
  font-size: 18px !important;
  color: #000 !important;
  padding: 10px;
  background-color: rgb(178, 217, 255);

  @media (max-width: 768px) {
    font-size: 14px !important;
  }
`;

const IndiaAITinkerpreneurPage2026 = () => {
  const token = localStorage.getItem("jwtToken");
  const year = 2026;
  const { t } = useTranslation();
  const [timelineData, setTimelineData] = useState([]);

  const fetchWorkshopData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/atl-tinkerpreneur/?year=${year}`,
        {
          headers: {
            "x-access-token": token,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      setTimelineData(data.workshops || []);
      return data.workshops || [];
    } catch (error) {
      console.error("Failed to fetch timeline data", error);
    }
  };

  const handleEnroll = async (event) => {
    try {
      await fetch(`${process.env.REACT_APP_API_URL}/atl-tinkerpreneur/enroll`, {
        method: "POST",
        headers: {
          "x-access-token": token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ event_id: event._id }),
      });
      await fetchWorkshopData();
    } catch (error) {
      console.error("Enrollment failed", error);
    }
  };

  useEffect(() => {
    const init = async () => {
      if (localStorage.getItem("jwtToken")) {
        await fetchWorkshopData();
      }
    };
    init();
  }, []);

  return (
    <>
      <div className="gray-light-bg">
        <div className="container d-flex justify-content-end">
          <LanguageSwitcher />
        </div>
        <div className="blog-container shadow px-0 pt-0 mt-0">
          <div className="pt-3">
            <ATLTinkerpreneurDeadlineNotice year={year} />
          </div>

          <div className="mar-t-15">
            <ATLTinkerpreneurBanner year={year} />
          </div>

          <Section className="px-md-2 px-xl-5 mx-auto">
            <ATLTinckerpreneurObjective year={year} />
          </Section>

          <Section className="px-md-2 px-xl-5 mx-auto">
            <div className="mt-md-2 row">
              <div className="col-md-12 mt-3">
                <Box className="w-100 p-3 p-md-5">
                  <h2 className="text-center mb-2 mb-md-4">
                    {t("atl_tinkerpreneur_2026.objective_title")}
                  </h2>
                  <div className="row">
                    <div className="col-md-12">
                      <p>{t("atl_tinkerpreneur_2026.objective_intro")}</p>
                      <p>
                        <strong>
                          {t("atl_tinkerpreneur_2026.objective_subtitle")}
                        </strong>
                      </p>
                      <ul
                        style={{ listStyleType: "disc", paddingLeft: "24px" }}
                      >
                        <li>{t("atl_tinkerpreneur_2026.objective_1")}</li>
                        <li>{t("atl_tinkerpreneur_2026.objective_2")}</li>
                        <li>{t("atl_tinkerpreneur_2026.objective_3")}</li>
                        <li>{t("atl_tinkerpreneur_2026.objective_4")}</li>
                        <li>{t("atl_tinkerpreneur_2026.objective_5")}</li>
                      </ul>
                    </div>
                  </div>
                </Box>
              </div>
            </div>
          </Section>

          {/* Six-phase roadmap — replaces the static journey image */}
          <ATLTinkerpreneurPhasesRoadmap />

          <div className="px-md-2 px-xl-5 mx-auto mt-md-4 mt-2">
            <div className="row">
              <div className="col-md-12 mt-3">
                <Box className="w-100 p-3 p-md-5">
                  <h2 className="text-center mb-2 mb-md-4">
                    {t("atl_tinkerpreneur.mentor_list_title")}
                  </h2>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="text-left">
                        {t("atl_tinkerpreneur.mentor_list_description")}
                        <a
                          style={{ color: "#0048ff" }}
                          href={`/assets/pdf/tinkerpreneur-${year}-mentors-list.pdf`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Click here to connect with a Mentor of Change.
                        </a>
                      </div>
                    </div>
                  </div>
                </Box>
              </div>
            </div>
          </div>

          <Section>
            <ATLTinckerpreneurTarget year={year} />
          </Section>
          {/*
          <div className="px-md-2 px-xl-5 mx-auto mt-md-4 mt-2">
            <AwardTxt className="w-100 mt-3">
              <div
                className="col-md-12 text-center"
                style={{ fontWeight: "bold" }}
              >
                {t("atl_tinkerpreneur.award_text")}
              </div>
            </AwardTxt>
          </div> */}

          {token && timelineData.length > 0 && (
            <Section>
              <ATLTinkerpreneurSessionCalendar
                key={timelineData.length}
                year={year}
                workshops={timelineData}
                handleEnroll={handleEnroll}
              />
            </Section>
          )}

          <div className="container">
            <Section className="px-md-2 px-xl-5 mx-auto">
              <ATLTinkerpreneurGuidelines year={year} />
            </Section>

            <Section className="px-md-2 px-xl-5 mx-auto">
              <ATLTinckerpreneurDisclaimer />
            </Section>
          </div>
        </div>
      </div>
    </>
  );
};

export default IndiaAITinkerpreneurPage2026;
